import { render, staticRenderFns } from "./comp_CheckoutDiscountForm-giftCardCode.vue?vue&type=template&id=07b63e1d&scoped=true"
import script from "./comp_CheckoutDiscountForm-giftCardCode.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutDiscountForm-giftCardCode.vue?vue&type=script&lang=js"
import style0 from "./comp_CheckoutDiscountForm-giftCardCode.vue?vue&type=style&index=0&id=07b63e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b63e1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
